<template>
  <div>

    <h1>Principal</h1>
    <b-nav vertical class="mb-4 mt-1">
      <b-nav-item :to="{ name: 'OrganizerEvents' }">
        <icon scale="0.9" name="bars"></icon> Eventos
      </b-nav-item>
      <b-nav-item :to="{ name: 'OrganizerBatches' }">
        <icon scale="0.9" name="book"></icon> Lotes
      </b-nav-item>
      <b-nav-item :to="{ name: 'OrganizerDealers' }">
        <icon scale="0.9" name="users"></icon> Revendedores
      </b-nav-item>
    </b-nav>

    <h1>Ingressos</h1>
    <b-nav vertical class="mb-4 mt-1">
      <b-nav-item :to="{ name: 'OrganizerCreateTickets' }">
        <icon scale="0.9" name="print"></icon> Imprimir
      </b-nav-item>
      <b-nav-item :to="{ name: 'OrganizerListTickets' }">
        <icon scale="0.9" name="ticket-alt"></icon> Impressos
      </b-nav-item>
    </b-nav>

    <!-- <div v-if="event.virtual_store === 1">
      <h1>Loja Virtual</h1>
      <b-nav vertical class="mb-4 mt-1">
        <b-nav-item :to="{ name: 'OrganizerCreateStore' }">
          <icon scale="0.9" name="shopping-bag"></icon> Loja virtual
        </b-nav-item>
        <b-nav-item v-if="event.has_online_dealer" :to="{ name: 'OrganizerOrdersList' }">
          <icon scale="0.9" name="shopping-cart"></icon> Pedidos
        </b-nav-item>
      </b-nav>
    </div> -->

    <h1>Validação</h1>
    <b-nav vertical class="mb-4 mt-1">
      <b-nav-item :to="{ name: 'OrganizerValidation' }">
        <icon scale="0.9" name="qrcode"></icon> Validação
      </b-nav-item>
    </b-nav>

    <h1>Relatórios</h1>
    <b-nav vertical class="mb-4 mt-1">
      <b-nav-item :to="{ name: 'OrganizerPrintReport' }">
        <icon scale="0.9" name="flag"></icon> Relatório de Impressão
      </b-nav-item>
      <b-nav-item :to="{ name: 'OrganizerValidationReport' }">
        <icon scale="0.9" name="flag"></icon> Relatório de Validação
      </b-nav-item>
      <b-nav-item :to="{ name: 'OrganizerTimeReport' }">
        <icon scale="0.9" name="flag"></icon> Relatório de Horário
      </b-nav-item>
    </b-nav>

  </div>
</template>

<script>
export default {
  name: 'OrganizerMenu'
}
</script>
